export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-11.a2c0472b.png";